import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import weather from "../weather/weather.vue";
import Menu from "../menu/menu.vue";
import data from "@/data/data";
import { watch } from "vue";
import backgroundUtil from "@/utils/backgroup";


export default /*#__PURE__*/_defineComponent({
  __name: 'background',
  setup(__props) {

watch(
    () => data.saveData.bgLink,
    () => {
        // 是否设置了壁纸，没设置则获取 bing
        if (data.saveData.bgSet) {
            backgroundUtil.setBg(data.saveData.bgLink);
        } else {
            backgroundUtil.getBing();
        }
    }
);

backgroundUtil.getBing();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "background",
    refname: "background",
    style: _normalizeStyle(_unref(data).backgroundCss),
    class: _normalizeClass({
            active: _unref(data).searchBoxFocus,
            activeBlur: !_unref(data).saveData.AeroState && _unref(data).searchBoxFocus
        })
  }, [
    _createVNode(weather),
    _createVNode(Menu)
  ], 6))
}
}

})